import React from 'react'
import {
	Routes,
	Route,
	BrowserRouter,
	Navigate
} from 'react-router-dom'
import './i18n';

import { getActiveSite, siteTypes } from './configs/sites';
import Ecommerce from './pages/Ecommerce';
import RootPlaceholder from './pages/RootPlaceholder';
import Home from './pages/Home'

// import Button from 'react-bootstrap/Button';


function App() {
	const activeSite = getActiveSite();

	if (activeSite.type === siteTypes.placeholder) {
		return <RootPlaceholder />
	}

	return (
		<div className='App'>
			<BrowserRouter>
				{/* <Link to='/'>Home</Link> */}

				<Routes>

					{/* redirect default */}
					<Route
						path="/"
						element={<Navigate to={`/${activeSite.defaultLanguage}/`} replace />}
					/>

					{/* multilingual */}
					<Route
						path="/:lng/*"
						element={<Home />}
					/>

					<Route
						path="/:lng/ecommerce"
						element={<Ecommerce />}
					/>

				</Routes>
			</BrowserRouter>
		</div>
	)
}

export default App
